import { useQueryParam } from '../useQueryParam';
import { getDateParam } from '../../browser';

export const useDatesParam = () => {
  const [date] = useQueryParam('date');
  const [compareDate] = useQueryParam('compareDate');
  const [clientCode] = useQueryParam('clientCode');
  return getDateParam({ date, compareDate, clientCode });
};
